import axios from "axios";

axios.interceptors.request.use(config => {
  const token = localStorage.getItem("token") ?? "";
  let port, user_id;

  if (localStorage.getItem("port_awal")) {
    port = JSON.parse(localStorage.getItem("port_awal")).value ?? "";
  } else {
    port = "";
  }

  if (localStorage.getItem("user")) {
    user_id = JSON.parse(localStorage.getItem("user")).user_id ?? "";
  } else {
    user_id = "";
  }

  config.params = {
    ...config.params,
    token,
    port,
    user_id
  };

  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response.status === 403 &&
      error.response.data.message === "No Access"
    ) {
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
